export const FETCH_USER = 'FETCH_USER'